export const tableHeaders = ["Logo", "Name", "Time Zone"];

export const MANAGER_CLIENTS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/clients", name: "Clients" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;
